export function GET_DOMAIN() {
    const host = window.location.hostname;
    console.log(host);
    return host;
  }